import React,{Component} from 'react';
import "./style.less"
import {NavBar} from "antd-mobile";
export default class InvoiceSucceed extends Component{
    constructor(props) {
        super(props);
    }
    render(){
        return(
            <div className="invoiceSucceed">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >
                    发票申请成功
                </NavBar>
                <div className="success">
                    <i className="icon iconfont iconchenggong"></i>
                </div>
                <div className="word">纸质发票将于申请后7个工作日内邮寄；</div>
                <div className="word">电子发票将于申请后7个工作日内上传，请前往发票详情查看进度。</div>
                <div className="btn">
                    {/*<div className="btn1" onClick={() => this.props.history.push('/invoice')}>开具发票</div>*/}
                    <button onClick={() => this.props.history.push('/invoiceHistory')}>发票历史</button>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Invoice/InvoiceSucceed/index.js